// location.href.indexOf('localhost:800') 主要是 prerender 阶段，动态加载的词条js文件出不来,否则可以不用
// eslint-disable-next-line no-undef
__webpack_public_path__ = location.href.indexOf('localhost:800') > -1 ? '/' : process.env.VUE_APP_PUBLICPATH;
